import { SettingsMessages, TranslationSettingsMessages } from "../interfaces";

export const messages: TranslationSettingsMessages = {
  [SettingsMessages.settingsTitle]: "Configurações",
  [SettingsMessages.parameters]: "Parâmetros",
  [SettingsMessages.timeForUndueStopOptionDescription]: "Tempo necessário para a parada de um veículo ser considerada uma parada indevida",
  [SettingsMessages.timeForUndueStopOptionHelper]:
    "Veículo parado fora de um local cadastrado por mais que esse tempo é classificado como parada indevida.",
  [SettingsMessages.functionalities]: "Funcionalidades",
  [SettingsMessages.enablePumpTimelineOptionDescription]: "Habilitar mapa de bombas",
  [SettingsMessages.enablePumpTimelineOptionHelper]:
    "Exibe o item \"Bombas\" (linha do tempo de bombas) no menu do sistema.",
  [SettingsMessages.enableWaterPostDischargeOptionDescription]: "Tratar adições pós-descarga na próxima viagem",
  // eslint-disable-next-line max-len
  [SettingsMessages.enableWaterPostDischargeOptionHelper]: "Quando ativo, a água adicionada após a descarga (água \"fina\", reaproveitada na carga seguinte) deixa de ser contabilizada na viagem atual e passa a ser atribuída à próxima viagem do veículo — exibida em bloco separado, com a referência à viagem de origem. Quando desativado, a água permanece na viagem atual (comportamento padrão).",
  [SettingsMessages.blockDate]: "Data de bloqueio",
  [SettingsMessages.blockDateHelper]:
    "Bloqueia o acesso ao sistema a partir desta data (uso administrativo, ex.: inadimplência). Em branco = sem bloqueio.",
  [SettingsMessages.minutes]: "Minutos",
  [SettingsMessages.defaultConstructionRadiusOptionDescription]: "Raio padrão de obra usado quando a obra não tem raio próprio cadastrado",
  [SettingsMessages.meters]: "Metros",
  [SettingsMessages.autoTravelMinStopMinutes]: "Tempo mínimo parado para entrar em obra (viagem automática, em minutos)",
  [SettingsMessages.timeForImproperDischargeOptionDescription]: "Tempo mínimo de um descarregamento fora de obra para gerar alerta",
  [SettingsMessages.timeForImproperDischargeOptionHelper]:
    "Descarregamento fora de um local cadastrado que dure menos que esse tempo não vira alerta. Evita o alerta com o sensor oscilando e o caminhão em movimento.",
  [SettingsMessages.seconds]: "Segundos",
};
